export default "__VITE_ASSET__BJavLPze__"